module.exports = __webpack_public_path__ + "fonts/Artifakt-Element-Thin.b87742aa.woff";